module.exports = __webpack_public_path__ + "img/35@2x.be9da7b3.png";